export enum QueryKey {
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
}
